import * as types from '../../actionTypes';

export const get = (pageNumber=null) =>{
  return{
    type: types.PETTY_CASHIER_GET_OVERALL_COST_DETAIL_REQUEST,
    pageNumber
  }
};

export const getSuccess = data => {
  return {
    type: types.PETTY_CASHIER_GET_OVERALL_COST_DETAIL_SUCCESS,
    payLoad: data
  };
};
export const getFailure = (error) => {
  return {
    type: types.PETTY_CASHIER_GET_OVERALL_COST_DETAIL_FAILURE,
    error: error
  };
};

export const remove = (id, type, pageNumber) => {
  return {
    type: types.PETTY_CASHIER_REMOVE_OVERALL_COST_DETAIL_REQUEST,
    id: id,
    _type: type,
    pageNumber
  }
};

export const removeSuccess = (data) =>{
  return {
    type: types.PETTY_CASHIER_REMOVE_OVERALL_COST_DETAIL_SUCCESS,
    payLoad: data
  }
};

export const removeFailure = () => {
  return {
    type: types.PETTY_CASHIER_REMOVE_OVERALL_COST_DETAIL_FAILURE
  };
};